<!--
  --
  -- カード用年月入力コンポーネント
  --
  -->
<template>
  <c-input
    class="c-card-expire-field"
    :label="label"
    :value="value"
    :rules="rules"
  >
    <div class="d-flex flex-nowrap w-full">
      <v-select
        class="c-card-expire-field-month"
        hide-details
        v-model="value.month"
        :items="monthItems"
        :disabled="Flags.disabled"
      />
      <v-select
        class="c-card-expire-field-year"
        hide-details
        v-model="value.year"
        :items="yearItems"
        :disabled="Flags.disabled"
      />
    </div>
  </c-input>
</template>

<script>
import CInput from '../CInput'

// import deepmerge from 'deepmerge'

export default {
  name: 'CExpireField',
  components: {
    CInput
  },

  // v-model の定義
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    // ラベル
    label: {
      type: String
    },

    // 値
    value: {
      type: Object,
      default: () => ({
        year: '',
        month: ''
      })
    },

    // 入力チェックルール
    rules: {
      type: Array,
      default: () => []
    },

    // オートフォーカス
    autofocus: {
      type: Boolean,
      default: false
    },

    // フラグ
    Flags: {
      disabled: false
    }
  },

  data: () => ({
    // 年月日 各項目の入力値
    /*
    input: {
      year: '',
      month: ''
    },
    */

    // 年, 月の選択肢
    yearItems: [],
    monthItems: MONTH_ITEMS
  }),

  created () {
    // 年の選択肢を生成する
    const min = new Date().getFullYear()
    const len = 14
    const years = new Array(len)
    for (let n = 0; n < len; ++n) {
      const y = '' + (n + min)
      years[n] = { value: y, text: y }
    }
    this.yearItems = years
  }

  /*
  watch: {
    // value プロパティが変化したら、input を更新する
    value: {
      immediate: true,
      handler (value) {
        this.input = deepmerge(value, {})
      }
    },

    // input が変化したら、change イベントを送出する
    input: {
      deep: true,
      handler (value) {
        console.log(value)
        // this.$emit('change', value)
      }
    }
  }
  */
}

const MONTH_ITEMS = [
  { value: '01', text: '01' },
  { value: '02', text: '02' },
  { value: '03', text: '03' },
  { value: '04', text: '04' },
  { value: '05', text: '05' },
  { value: '06', text: '06' },
  { value: '07', text: '07' },
  { value: '08', text: '08' },
  { value: '09', text: '09' },
  { value: '10', text: '10' },
  { value: '11', text: '11' },
  { value: '12', text: '12' }
]
</script>

<style lang="scss">
.c-card-expire-field {
  width: 10rem;

  .v-select__selections {
    position: relative;

    .v-select__selection--comma {
      margin-right: 0;
      max-width: 100%;
    }

    input[type="text"][readonly="readonly"] {
      position: absolute;
      left: -9999px;
    }
  }

  %field {
    margin-top: 0;
    padding-top: 0;
  }

  .c-card-expire-field-year {
    @extend %field;
    margin-right: .5rem;
    flex: 1 1;
  }
  .c-card-expire-field-month {
    @extend %field;
    margin-right: .5rem;
    flex: 0 0;
    flex-basis: 4rem;
  }
}
</style>
